// komponent Checkbox - lokalny override
// @ts-nocheck

import React, { FC } from 'react';
import { Checkbox as CheckboxMui } from '@mui/material';
import classnames from 'classnames';

import styles from 'theme/components/controls/Checkbox/Checkbox.module.scss';

// typ danych wejściowych
interface IProps {
  checked: boolean;
  disabled?: boolean;
  indeterminate?: boolean;
  id?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Checkbox: FC<IProps> = ({ checked, disabled, onClick, onChange, indeterminate, id }) => (
  <span
    className={classnames(
      styles.componentWrapper,
      { [styles.disabled]: !!disabled },
      'StylePath-Components-Controls-Checkbox'
    )}>
    <CheckboxMui
      id={id}
      className={classnames(styles.checkbox, {
        [styles.checked]: checked,
        [styles.indeterminate]: indeterminate
      })}
      checked={checked}
      indeterminate={indeterminate}
      onClick={onClick}
      onChange={onChange}
      disabled={disabled}
      sx={{
        padding: '0 !important'
      }}
    />
  </span>
);

export default Checkbox;
